import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/query-keys';
import { financialService } from '../../services/financial.service';

export function usePayments(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.payments.all(orgId ?? ''),
    queryFn: () => financialService.getStandalonePayments(),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => Array.isArray(res.data) ? res.data : [],
  });
}
